import * as gtag from "../../utils/gtag";

export const sendDownloadPreview = (previewCategory, previewTitle, previewDimension) => {
    gtag.overallEvent('download_preview', `${previewCategory}|${previewTitle}|${previewDimension}`);
}

export const sendEditPreview = (previewCategory, previewTitle, previewDimension) => {
    gtag.overallEvent('edit_preview', `${previewCategory}|${previewTitle}|${previewDimension}`);
}

export const sendSelectAllPreview = (previewCategory) => {
    gtag.overallEvent('click_select_all_preview', `${previewCategory}`);
}

export const sendDownloadSelectPreview = (previewCategory, previewItems) => {
    gtag.overallEvent('download_preview_selected', `${previewCategory}|${previewItems}`);
}

export const sendSelectPreview = (category, previewName, previewDimensions) => {
    gtag.overallEvent('click_select_preview', `${category}|${previewName}|${previewDimensions}`);
}

export const sendClickCategoryScroll = () => {
    gtag.overallEvent('click_scroll_cat_resize', 'unknown');
}

export const sendClickCategoryPreview = (category = 'unknown') => {
    gtag.overallEvent('click_cat_resize', category);
}

export const sendClickUpload = (label) => {
    gtag.overallEvent('click_upload', label);
}
